import React from 'react';

import { FormControl, Select, MenuItem, Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@mui/icons-material';

import { TYPE_OPTIONS } from '../../constants/observations';

const useStyles = makeStyles((theme) => ({
  '.makeStyles-select .MuiInput-underline:before': {
    border: 'none !important',
  },
  checkbox: {
    padding: 0,
    paddingRight: 8,
  },
  closeIcon: {
    '&:hover': {
      color: '#333',
      cursor: 'pointer',
    },
    color: '#aaa',
    display: 'none !important',
    padding: 2,
    position: 'absolute',
    right: 20,
    top: 4,
  },
  inputContainer: {
    '& .NativeDatepicker, .NativeDatepicker .MuiBox-root, & select': {
      height: 30,
      width: 140,
    },
    '&:hover>.MuiSvgIcon-fontSizeSmall': {
      display: 'block !important',
    },
    position: 'relative',
  },
  list: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  menu: {
    border: '2px solid #E7E7E7',
    borderRadius: 5,
    boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
    paddingBottom: '1rem',
  },
  menuItem: {
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: 'white',
    },
    height: 40,
  },
  select: {
    '& .MuiInputBase-input': {
      color: '#999',
      fontFamily: 'Roboto',
      fontSize: 13,
      height: 30,
      padding: '0 5px',
    },
    '&:focus': {
      borderColor: theme.palette.primary.main,
      color: '#444',
      outline: 'none',
    },
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: '#444',
      cursor: 'pointer',
    },
    border: '1px solid #C8C8C8',
    borderRadius: 8,
    color: '#999',
    height: 30,
    overflow: 'hidden',
    width: 127,
  },
}));

const TypeMultiSelect = ({ selectedType = [], onChange, className = '', placeholder = 'Type', multiple = true }) => {
  const classes = useStyles();

  const renderSelectedTypesLabel = (values) => {
    if (!values.length) return placeholder;

    if (values.length === 1) {
      const type = TYPE_OPTIONS.find((t) => t.value === values[0]);
      return type ? type.label : values[0];
    }

    if (values.length < TYPE_OPTIONS.length) {
      const firstType = TYPE_OPTIONS.find((t) => t.value === values[0]);
      return `${firstType ? firstType.label : values[0]} + ${values.length - 1}`;
    }

    return 'All Types';
  };

  const handleReset = () => {
    onChange(multiple ? [] : '');
  };

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  if (!multiple) {
    // Single select version for backward compatibility
    return (
      <div className={`${classes.inputContainer} ${className}`}>
        <select
          className={classes.select}
          id="typeSelect"
          value={selectedType}
          onChange={handleChange}
          style={{
            '&:hover': {
              borderColor: '#1976d2',
              color: '#444',
              cursor: 'pointer',
            },
            border: '1px solid #C8C8C8',
            borderRadius: 8,
            color: '#999',
            height: 40,
            padding: '0 16px',
            width: '127px !important',
          }}>
          <option value="">{placeholder}</option>
          {TYPE_OPTIONS.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
        {!!selectedType && <Close fontSize="small" className={classes.closeIcon} title="Reset Value" onClick={handleReset} />}
      </div>
    );
  }

  return (
    <div className={`${classes.inputContainer} ${className}`}>
      <FormControl className={classes.select}>
        <Select
          id="typeSelect"
          multiple
          displayEmpty
          value={selectedType}
          onChange={handleChange}
          renderValue={(val) => renderSelectedTypesLabel(val)}
          MenuProps={{
            anchorOrigin: {
              horizontal: 'left',
              vertical: 'bottom',
            },
            classes: {
              list: classes.list,
              paper: classes.menu,
            },
            getContentAnchorEl: null,
          }}>
          {TYPE_OPTIONS.map((type) => (
            <MenuItem className={classes.menuItem} key={type.value} value={type.value}>
              <Checkbox className={classes.checkbox} checked={selectedType.indexOf(type.value) > -1} />
              {type.label}
            </MenuItem>
          ))}
        </Select>

        {selectedType.length > 0 && <Close fontSize="small" className={classes.closeIcon} title="Reset Value" onClick={handleReset} />}
      </FormControl>
    </div>
  );
};

export default TypeMultiSelect;
